module.exports = __webpack_public_path__ + "assets/img/forgot-password-v2-dark.4bb55df3.svg";